import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig } from '../../../models/https';
import {
  ReferralLeaderboardMode,
} from '../../../models/referral/referral.model';
import { normalizeReferralLeaderboardEntries } from '../../../models/referral/referral.adapters';
import { referralActions } from '../../../redux/slices/referralSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useGetReferralLeaderboard = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const [loading, setLoading] = useState(false);

  const onSuccess = (response: unknown) => {
    const entries = normalizeReferralLeaderboardEntries(response);
    dispatch(referralActions.setReferralLeaderboard(entries));
    dispatch(referralActions.setReferralLeaderboardError(null));
  };

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while fetching referral leaderboard'
    );
    dispatch(referralActions.setReferralLeaderboard([]));
    dispatch(
      referralActions.setReferralLeaderboardError(
        'Leaderboard data is not available right now. Please try again.'
      )
    );
  };

  const getReferralLeaderboard = (mode: ReferralLeaderboardMode) => {
    dispatch(referralActions.setReferralLeaderboardMode(mode));

    const url: HttpConfig = {
      url: `auth-service/users/referrals/leaderboard?mode=${mode}`,
      method: 'get',
    };

    return request(url, onSuccess, setLoading, onError);
  };

  return { getReferralLeaderboard, loading };
};

export default useGetReferralLeaderboard;
